export default __webpack_public_path__ + "models/ce18684e22782f132d90e0517de32b60.glb";